import { ElLoading } from 'element-plus'

export function downExcel(res, fileName) {
    var blob = new Blob([res.data], {
        type: 'application/octet-stream;charset=UTF-8',
    })
    var downloadElement = document.createElement('a');
    var href = window.URL.createObjectURL(blob);
    downloadElement.style.display = 'none';
    downloadElement.href = href;
    downloadElement.download = decodeURI(fileName + '.xlsx');
    document.body.appendChild(downloadElement);
    downloadElement.click();
    document.body.removeChild(downloadElement);
    window.URL.revokeObjectURL(href);
}
 
export function downPDF(res, fileName) {
    const blob = new Blob([res.data], { type: 'application/pdf' });
    const href = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = href;
    a.download = decodeURIComponent(fileName) + '.pdf'; // 若 fileName 未编码则用 fileName
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => window.URL.revokeObjectURL(href), 1000);
}
export function downZip(res, fileName) {
    var blob = new Blob([res.data], {
        type: 'application/octet-stream;charset=UTF-8',
    })
    var downloadElement = document.createElement('a');
    var href = window.URL.createObjectURL(blob);
    downloadElement.style.display = 'none';
    downloadElement.href = href;
    downloadElement.download = decodeURI(fileName + '.zip');
    document.body.appendChild(downloadElement);
    downloadElement.click();
    document.body.removeChild(downloadElement);
    window.URL.revokeObjectURL(href);
}
export function loading(tipText) {
    var loading = ElLoading.service({
        lock: true,
        text: tipText,
        background: "rgba(0, 0, 0, 0.7)",
    });
    return loading;
}

//选择学校后加载学校对应的年级
export function schoolChage(schoolList, gradeList, schoolId) {
    //通过学校Id找到对应的学校信息
    var schoolObj = schoolList.filter((item) => {
        return item.id == schoolId;
    });
    //拿到学校的schoolType与年级gradeList集合中的schoolType的匹配
    //得到对应学校类型下的年级
    var _gradeList = gradeList.filter((item) => {
        return item.schoolType == schoolObj[0].schoolType;
    });
    //按一二十三四五六给对象中添加排序字段orderIndex
    if (_gradeList != null && _gradeList.length > 0) {
        _gradeList.forEach((m) => {
            if (m.name.indexOf("一") > -1) m.orderIndex = 1;
            else if (m.name.indexOf("二") > -1) m.orderIndex = 2;
            else if (m.name.indexOf("三") > -1) m.orderIndex = 3;
            else if (m.name.indexOf("四") > -1) m.orderIndex = 4;
            else if (m.name.indexOf("五") > -1) m.orderIndex = 5;
            else m.orderIndex = 6;
        });
        //排序
        _gradeList = _gradeList.sort(function (a, b) {
            return a.orderIndex < b.orderIndex
                ? -1
                : a.orderIndex > b.orderIndex
                    ? 1
                    : 0;
        });
    }
    return _gradeList;
};

//将el-uplod上传的图片转为base64
export function getBase64(file) {
    return new Promise(function (resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function () {
            imgResult = reader.result;
        };
        reader.onerror = function (error) {
            reject(error);
        };
        reader.onloadend = function () {
            resolve(imgResult);
        };
    });
}

/* 日期格式化 */
export function dateFormat(date, fmt = 'yyyy-MM-dd hh:mm:ss') {
	date = new Date(date)
	var o = {
		"M+": date.getMonth() + 1,                 
		"d+": date.getDate(),                    
		"h+": date.getHours(),                   
		"m+": date.getMinutes(),                
		"s+": date.getSeconds(),               
		"q+": Math.floor((date.getMonth() + 3) / 3), 
		"S": date.getMilliseconds()            
	};
	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
	}
	for (var k in o) {
		if (new RegExp("(" + k + ")").test(fmt)) {
			fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
		}
	}
	return fmt;
}

export function subjectTypeList( ) {
 
	const subjectTypeList = [
	  { subjectType: 1, subjectName: "语文" },
	  { subjectType: 2, subjectName: "数学" },
	  { subjectType: 3, subjectName: "英语" },
	  { subjectType: 4, subjectName: "物理" },
	  { subjectType: 5, subjectName: "历史" },
	  { subjectType: 6, subjectName: "化学" },
	  { subjectType: 7, subjectName: "生物" },
	  { subjectType: 8, subjectName: "政治" },
	  { subjectType: 9, subjectName: "地理" },
	  { subjectType: 10, subjectName: "日语" },
	  { subjectType: 11, subjectName: "俄语" }, 
	  { subjectType: 12, subjectName: "道法" }, 
	  { subjectType: 13, subjectName: "数学选修"}, 
	  { subjectType: 14, subjectName: "物理选修"}, 
	  { subjectType: 15, subjectName: "化学选修"}, 
	  { subjectType: 16, subjectName: "生物选修"}, 
	  { subjectType: 17, subjectName: "历史选修"}, 
	  { subjectType: 18, subjectName: "政治选修"},
	  { subjectType: 19, subjectName: "地理选修"}, 
	  { subjectType: 99, subjectName: "信息" },
	  { subjectType: 100, subjectName: "体育" },
	  
	]
return  subjectTypeList;
}

/**
 * 判断答题卡背面图片是否有效（应显示）
 * 当接口返回的 answerSheetPageTwoImg 或 secondPageCosPath 为空、
 * 或指向占位图（a4_nopic_second.jpg / a3_nopic_second.jpg）时，返回 false（不显示）
 * @param {string} imgUrl - 答题卡背面图片地址
 * @returns {boolean} true = 有效，显示；false = 无效，不显示
 */
export function isAnswerSheetSecondPageValid(imgUrl) {
  if (!imgUrl) return false
  // 占位图文件名列表
  const noPicNames = ['a4_nopic_second.jpg', 'a3_nopic_second.jpg']
  return !noPicNames.some((name) => imgUrl.includes(name))
}
